//@ts-check
import { conversationService } from 'config/api';
import actionTypes from './actionTypes';

export const addCurrentDraft = (currentDraft) => ({
  type: actionTypes.ADD_CURRENT_DRAFT,
  payload: currentDraft,
});

export const removeCurrentDraft = () => ({
  type: actionTypes.REMOVE_CURRENT_DRAFT,
});

export const addDraftItems = (draftItems) => ({
  type: actionTypes.ADD_DRAFT_ITEMS,
  payload: draftItems,
});

export const removeDraftItems = (draftItemId) => ({
  type: actionTypes.REMOVE_DRAFT_ITEMS,
  payload: draftItemId,
});

export const getDraftMessages = () => async (dispatch) => {
  dispatch({
    type: actionTypes.GET_ASSOCIATE_DRAFT_MESSAGES_LOADING,
  });

  const { data } = await conversationService.get('/v1/drafts');
  dispatch({
    type: actionTypes.GET_ASSOCIATE_DRAFT_MESSAGES_SUCCESS,
    payload: data,
  });
};

export const updateDraftMessage = (payload) => async (dispatch) => {
  const { messageId } = payload;
  const { data } = await conversationService.put(`/v1/drafts/${messageId}`, payload);
  dispatch({
    type: actionTypes.UPDATE_ASSOCIATE_DRAFT_MESSAGE,
    payload: data,
  });
  return data;
};

export const createDraftMessage = (payload) => async (dispatch) => {
  const { data } = await conversationService.post('/v1/drafts', payload);
  dispatch({
    type: actionTypes.CREATE_ASSOCIATE_DRAFT_MESSAGE,
    payload: data,
  });
  return data;
};

export const deleteDraftMessage = (payload) => async (dispatch) => {
  await conversationService.delete(`/v1/drafts/${payload.messageId}`);
  dispatch({
    type: actionTypes.DELETE_ASSOCIATE_DRAFT_MESSAGE,
    payload,
  });
};
